/**
 * @file BgFrameStep.tsx
 * @description Шаг «Кадр под блок» для фото фона секции (phase19.16, партия
 * SB120, этап 1; uiux-sb120-stage1 §2.4): рамка — ширина блока × высота
 * (телефон — 360 × высота телефона или 4:5), числом — масштаб, «Другое фото
 * для телефона», предупреждение «Фото N px уже кадра». Общий шаг —
 * `FrameStep`; здесь — что у фона.
 */

import type { SectionLook, SectionMediaBg } from "@chaiberi/shared";

import { useSectionForm } from "../section-form-context";
import { FrameStep } from "./FrameStep";
import { mediaAspect } from "../../../../hooks/site-builder/useMediaSizes";
import { frameToBg, type FrameDraft } from "../../../../lib/site-builder/frame-draft";
import { frameAspect, type Device } from "../../../../lib/site-builder/look-size";
import { frameWarnings, lookWarningText } from "../../../../lib/site-builder/look-warnings";

interface Props {
  open: boolean;
  look: SectionLook;
  bg: SectionMediaBg;
  initial: FrameDraft;
  device: Device;
  onDone: (draft: FrameDraft) => void;
  onClose: () => void;
  onPickPhone: (draft: FrameDraft) => void;
}

export function BgFrameStep({ open, look, bg, initial, device, onDone, onClose, onPickPhone }: Props) {
  const { mediaSizes, theme } = useSectionForm();
  const fileOf = (d: Device, draft: FrameDraft) => (d === "phone" ? (draft.mediaIdPhone ?? bg.mediaId) : bg.mediaId);
  return (
    <FrameStep
      open={open}
      mediaId={bg.mediaId}
      initial={initial}
      device={device}
      numbers="zoom"
      aspectOf={(d, draft) => frameAspect(look, d, mediaAspect(mediaSizes, fileOf(d, draft)))}
      warningOf={(d, draft) => {
        // Пока размеры файла не известны — молчим: иначе текст меняется после загрузки (QA D7).
        const fileWidth = mediaSizes[fileOf(d, draft)]?.width;
        if (!fileWidth) return null;
        const path = d === "phone" ? "look.bg.mediaIdPhone" : "look.bg.mediaId";
        const found = frameWarnings({ ...look, bg: frameToBg(bg, draft) }, theme, mediaSizes).find((w) => w.path === path);
        return found ? lookWarningText(found, { fileWidth }) : null;
      }}
      onPickPhone={onPickPhone}
      onDone={onDone}
      onClose={onClose}
    />
  );
}
